// tslint:disable:max-line-length

import React from 'react';

import { Button, PresetThemes } from '@travelnest/merlin.button';
import { Modal } from '@travelnest/merlin.modal';
import { Rule } from '@travelnest/merlin.rule';
import { MarginWrapper } from '@travelnest/merlin.spacer';
import { Paragraph } from '../../paragraph/Paragraph';

interface ICalendarSyncExportWizardActionProps {
	propertyId: number | string;
	onRequestNext: () => any;
	onRequestPrevious: () => any;
	onRequestClose: () => any;
}

export const CalendarSyncExportWizardAction: React.FC<ICalendarSyncExportWizardActionProps> = (props) => {
	const { onRequestNext, onRequestClose, propertyId } = props;
	const [copyButtonText, setCopyButtonText] = React.useState('Copy link');
	const apiUrl = `https://api.travelnest.com/ical?id=${propertyId}`;

	const copy = () => {
		navigator.clipboard.writeText(apiUrl);
		setCopyButtonText('Copied');
	};

	return (
		<Modal
			extraClasses="calendar-sync-modal calendar-sync-modal--export"
			title="Export your calendar"
			onRequestClose={onRequestClose}
			shouldCloseOnOverlayClick={false}
			actionRHS={
				<Button
					id="calendar_export_action_next"
					onClick={onRequestNext}
					buttonType={PresetThemes.Primary}
				>
					<span>Continue</span>
				</Button>
			}
		>
			<MarginWrapper>
				<h3>Export your Travelnest calendar.</h3>
				<Paragraph>Paste the link below into your external platforms.</Paragraph>
				<Paragraph>When we receive a booking we will automatically update your external calendars.</Paragraph>
				<Rule />
				<h4 id="calendar-sync-url">{apiUrl}</h4>
				<Rule />
				<Button
					id="calendar_export_copy"
					onClick={copy}
				>
					<span>{copyButtonText}</span>
				</Button>
			</MarginWrapper>
		</Modal>
	);
};
